import React from 'react';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormInput, FormAutocomplete } from './FormControls';

const SupplierField = ({ supplierList = [], gridSize = { xs: 12, sm: 4 } }) => {
  const { watch } = useFormContext();
  const supplierName = watch('supplierName');

  console.log("supplierName ===", supplierName);

  return (
    <>
      <Grid item {...gridSize}>
        <FormAutocomplete
          name="supplierName"
          label="Supplier Name"
          data={[...supplierList.map(s => s.supplierName), 'Other']}
        />
      </Grid>

      {supplierName === 'Other' && (
        <Grid item {...gridSize}>
          <FormInput
            name="otherSupplierName"
            label="Other Supplier Name"
            placeholder="Enter supplier name"
            required
          />
        </Grid>
      )}
    </>
  );
};

export default SupplierField;